'use client';
import Icon from '@egalite/ui/Icon';
import CreateProfileBanner from '@egalite/ui/IncluiPCD/CreateProfileBanner';
import Section from '@egalite/ui/IncluiPCD/Section';
import SectionTitle from '@egalite/ui/IncluiPCD/SectionTitle';
import Link from 'next/link';
import { FC, useEffect, useState } from 'react';
import Cookies from 'js-cookie';

const TitleSection: FC = () => {
	const [token, setToken] = useState(null);
	const [user, setUser] = useState(null);
	useEffect(() => {
		const token = Cookies.get('token');
		setToken(token);
		if (token && (user == null || Object.keys(user).length === 0)) {
			fetch('/api/v1/auth/fetchUser', {
				headers: {
					Authorization: `${token}`,
				},
				method: 'GET',
			})
				.then(res => res.json())
				.then(data => {
					setUser(data.data);
				});
			return;
		}
	}, [user]);
	return (
		<div className="container mt-12 md:mt-24">
			<div className='w-full'>
				<Link href={(user ?? {}).type === 'candidate' ? '/candidato' : '/'} className="w-max text-xs font-bold flex gap-4 text-brand-main mr-auto">
					<Icon name="arrow-left" /> {(user ?? {}).type === 'candidate' ? 'VOLTAR' : 'HOME'}
				</Link>
				{/* h1 da rota /busca-de-vagas — a página não tinha nenhum. */}
				<SectionTitle asEl="h1" className="mr-auto">Buscar Vagas</SectionTitle>
			</div>
			{/* {token ? null : <div className='mt-24 mb-4 md:mb-28'>
				<CreateProfileBanner />
			</div>} */}
		</div>
	);
};

export default TitleSection;
